import { render, staticRenderFns } from "./PresentacionUpdateListView.vue?vue&type=template&id=0b431340&scoped=true&"
import script from "./PresentacionUpdateListView.vue?vue&type=script&lang=js&"
export * from "./PresentacionUpdateListView.vue?vue&type=script&lang=js&"
import style0 from "./PresentacionUpdateListView.vue?vue&type=style&index=0&id=0b431340&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b431340",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
})
